import { useExportFileDownload } from '@Hooks/Documents';
import { LinkedCell } from '@synqo/frontend-component-library';
import { useCallback, type FC } from 'react';

export interface FileDownloadCellProps {
    fileId: string;
    label?: string;
}

export const FileDownloadCell: FC<FileDownloadCellProps> = ({ label = 'Download', fileId }) => {
    const { downloadExportFile } = useExportFileDownload();

    const handleDownload = useCallback(() => {
        void downloadExportFile(fileId);
    }, [downloadExportFile, fileId]);

    return <LinkedCell label={label} itemId={fileId} onClick={handleDownload} />;
};
